/**
 * PageOB404.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';

//material-ui
import Grid from '@material-ui/core/Grid';

class Legales extends Component {
    constructor(){
        super()
    }

    render(){
        const {classes} = this.props;

        return (
            <p className={classes.box}> 
                LA PRESENTE NO IMPLICA OFERTA DE CRÉDITO NI ACEPTACIÓN DE LA SOLICITUD POR PARTE DE ESTE BANCO. CONSULTE CONDICIONES VIGENTES AL MOMENTO DE CONTRATACIÓN. EL EFECTIVO OTORGAMIENTO DE LA TARJETA DE CRÉDITO SE ENCUENTRA SUJETO A LA APROBACIÓN PREVIA POR PARTE DE ESTE BANCO.(1) EL CARGO DE RENOVACIÓN ANUAL SERÁ BONIFICADO SIEMPRE QUE EL CLIENTE SEA TITULAR DE UN PAQUETE MULTIPRODUCTO VIGENTE.(2) PROGRAMA AEROLÍNEAS PLUS ORGANIZADO Y ADMINISTRADO POR AEROLÍNEAS ARGENTINAS S.A. CARGO MEMBRESÍA $1.350 + IVA. CONSULTE TÉRMINOS Y CONDICIONES EN <span className={classes.miniNaranja}>www.hipotecario.com.ar</span> O EN <span className={classes.miniNaranja}>www.aerolineasargentinas.com.</span> BANCO HIPOTECARIO S.A. CUIT N°30-50001107/2 RECONQUISTA 151 (1003), CABA.
            </p>
        );    
    }
}

const styles = theme => ({
    box : {
        padding: theme.spacing.unit * 2,
        fontFamily: "Roboto",
        fontSize: "12px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: 1.42,
        letterSpacing: "normal",
        color: "#7e7e7e",
        backgroundColor: "#f1f1f1",
        textAlign: "justify"
    },
    miniNaranja:{
        color: '#f47321',
    },
    '@media screen and (min-width: 787px)': {
        box:{
            display : "none"
        }
    }
});

export default withStyles(styles)(Legales);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/error/Legales.js